import React from 'react'

interface IPanelBreadcrumbsProps {
  unknown?: unknown
}

const PanelBreadcrumbs: React.FC<IPanelBreadcrumbsProps> = () => {
  {
    /* {breadcrumbGroups.length > 1 && (
              <IconButton
                icon='statusBack'
                name='groupBack'
                onClick={goBack}
                size={KitSize.S}
                styleType='free'
              />
            )}
            {breadcrumbGroups.map((item, i) => (
              <span
                className={cn({ [s.selected]: i === breadcrumbGroups.length - 1 })}
                key={item.name}
              >
                {item.label}
                {i < breadcrumbGroups.length - 1 && (
                  <span className={s.divider}>&nbsp;/&nbsp;</span>
                )}
              </span>
            ))} */
  }
  return null
}

export default React.memo(PanelBreadcrumbs) as typeof PanelBreadcrumbs
